import serverless from "../../assets/aws-serverless.png";
import github from "../../assets/github.png";
import next from "../../assets/next.webp";
import nodejs from "../../assets/node-js.png";
import reactImage from "../../assets/react.png";
import sql from "../../assets/sql.png";
import tailwind from "../../assets/tailwind.png";
import typescript from "../../assets/typescript.png";

const techs = [
  {
    id: 1,
    src: next,
    title: "Next.js",
    style: "shadow-orange-500",
    aos: "fade-down-right",
  },

  {
    id: 2,
    src: typescript,
    title: "Typescript",
    style: "shadow-yellow-500",
    aos: "fade-down",
  },
  {
    id: 3,
    src: serverless,
    title: "AWS Serverless",
    style: "shadow-blue-500",
    aos: "fade-down-left",
  },
  {
    id: 4,
    src: reactImage,
    title: "React",
    style: "shadow-blue-600",
    aos: "fade-down-right",
  },
  {
    id: 6,
    src: nodejs,
    title: "Node.js",
    style: "shadow-purple-500",
    aos: "zoom-in",
  },
  {
    id: 5,
    src: tailwind,
    title: "Tailwind",
    style: "shadow-sky-500",
    aos: "fade-down-left",
  },
  {
    id: 7,
    src: sql,
    title: "SQL",
    style: "shadow-purple-500",
    aos: "fade-down-right",
  },
  {
    id: 8,
    src: github,
    title: "Git",
    style: "shadow-gray-400",
    aos: "zoom-in",
  },
];
export default techs;
